const home = {
  nav_home: 'Startseite',
  nav_guides: 'Guides',
  nav_reviews: 'Bewertungen',
  nav_shipping: 'Versand',
  nav_qc: 'QC',
  nav_safety: 'Sicherheit',
  nav_faq: 'FAQ',
  nav_about: 'Über Uns',
  nav_contact: 'Kontakt',
  nav_article: 'Artikel',
  lang_english: 'English',
  lang_french: 'Français',
  lang_danish: 'Dansk',
  lang_german: 'Deutsch',
  hero_title: 'AllChinaBuy Spreadsheet: Ihre Komplette Ressource für Kauf und Versand',
  hero_subtitle: 'Finden, vergleichen und verstehen Sie AllChinaBuy-Produkte mit einer praktischen Ressource.',
  hero_desc: 'Das AllChinaBuy Spreadsheet vereint Produktsrecherche-Ressourcen, Verkäuferinformationen, QC-Leitfäden, Versandtipps, Kauftutorials und AllChinaBuy-bezogene Informationen in einem benutzerfreundlichen Hub.',
  cta_primary: 'Das AllChinaBuy Spreadsheet Erkunden',
  cta_secondary: 'Mit dem Einsteiger-Guide Beginnen',
  cta_main_site: 'Hauptwebsite Besuchen',
  cta_buy_now: 'Jetzt Kaufen',
  trust_text: 'Unabhängige Informationsressource • Regelmäßig aktualisiert • Für intelligentere Produktsrecherche gebaut',
  section_what_is_title: 'Was ist das AllChinaBuy Spreadsheet?',
  section_what_is_desc: 'Das AllChinaBuy Spreadsheet ist eine zentralisierte Ressource, die die Produktsrecherche erleichtern soll. Erkunden Sie organisierte Produktressourcen, Verkäuferinformationen, QC-Leitfäden, Versandreferenzen und praktische Kauftutorials von einem Ort aus.',
  section_resources_title: 'Alles, Was Sie für die AllChinaBuy-Recherche Brauchen',
  card_spreadsheet_title: 'Spreadsheet',
  card_spreadsheet_desc: 'Erkunden Sie organisierte AllChinaBuy-Produkt- und Verkäuferressourcen.',
  card_shipping_title: 'Versand',
  card_shipping_desc: 'Verstehen Sie Versandmethoden, Kosten und praktische Vergleichsfaktoren.',
  card_qc_title: 'QC',
  card_qc_desc: 'Lernen Sie, was vor dem Versand von Produkten zu prüfen ist.',
  card_sellers_title: 'Verkäufer',
  card_sellers_desc: 'Lernen Sie, wie Sie Verkäufer recherchieren und Produktinformationen bewerten.',
  card_reviews_title: 'Bewertungen',
  card_reviews_desc: 'Lesen Sie unabhängige AllChinaBuy-Leitfäden und Analysen.',
  card_safety_title: 'Sicherheit',
  card_safety_desc: 'Lernen Sie, verdächtige Links, Zahlungsanforderungen und häufige Risiken zu erkennen.',
  section_categories_title: 'AllChinaBuy Spreadsheet Kategorien',
  section_compare_title: 'Vergleichen Sie, Bevor Sie Kaufen',
  section_compare_desc: 'Verschiedene Kaufplattformen können unterschiedliche Workflows, Versandoptionen und Benutzererfahrungen haben. Unsere Vergleichsleitfäden helfen Ihnen, die Unterschiede zu verstehen, bevor Sie eine Entscheidung treffen.',
  cta_view_comparisons: 'Alle Vergleiche Anzeigen',
  section_shipping_title: 'Versand Sollte Kein Rätsel Sein',
  section_shipping_desc: 'Die Versandkosten hängen von Faktoren wie Ziel, Paketgewicht, Abmessungen, Versandmethode und aktuellen Transporteurpreisen ab.',
  cta_explore_shipping: 'Versandleitfäden Erkunden',
  section_safety_title: 'Mit Sicherheit im Hinterkopf Gebaut',
  section_safety_desc: 'Bevor Sie auf einen Produktlink klicken, eine Zahlung senden oder persönliche Informationen teilen, überprüfen Sie, was Sie verwenden. Unser Sicherheitszentrum erklärt häufige Risiken, verdächtige Links, Kontosicherheit und Zahlungssicherheit.',
  cta_visit_safety: 'Sicherheitszentrum Besuchen',
  section_guides_title: 'Neueste AllChinaBuy-Leitfäden',
  section_faq_title: 'Häufig Gestellte Fragen',
  faq_q1: 'Was ist das AllChinaBuy Spreadsheet?',
  faq_a1: 'Das AllChinaBuy Spreadsheet ist eine unabhängige Informationsressource, die Produktsrecherche, Verkäuferinformationen, Versandleitfäden und Kauftutorials für Nutzer organisiert, die AllChinaBuy-Produkte recherchieren.',
  faq_q2: 'Ist AllChinaBuy legitim?',
  faq_a2: 'AllChinaBuy ist eine bekannte Einkaufsagentur-Plattform. Wir bieten unabhängige Leitfäden und Ressourcen, um Nutzern bei fundierten Entscheidungen zu helfen.',
  faq_q3: 'Ist AllChinaBuy sicher?',
  faq_a3: 'Sicherheit hängt davon ab, bewährte Praktiken zu befolgen: Links zu verifizieren, sichere Zahlungsmethoden zu verwenden, Verkäuferbewertungen zu prüfen und die Plattformrichtlinien zu verstehen.',
  faq_q4: 'Wie viel kostet der AllChinaBuy-Versand?',
  faq_a4: 'Versandkosten variieren je nach Ziel, Gewicht, Abmessungen und Versandmethode. Unsere Versandleitfäden erklären, wie Sie Kosten schätzen und vergleichen.',
  faq_q5: 'Wo finde ich AllChinaBuy-Gutscheine?',
  faq_a5: 'Gutscheine und Rabattcodes können über verschiedene Kanäle verfügbar sein. Wir aktualisieren unseren Gutscheinleitfaden mit verifizierten Informationen.',
  faq_q6: 'Was ist das AllChinaBuy-Lager?',
  faq_a6: 'Das Lager ist der Ort, an dem Produkte vor dem internationalen Versand gelagert werden. Das Verständnis der Lagerprozesse hilft Ihnen, Ihre Bestellungen besser zu planen.',
  faq_q7: 'Wie funktioniert AllChinaBuy QC?',
  faq_a7: 'Qualitätskontrolle (QC) beinhaltet die Inspektion von Produkten, bevor sie an Sie versendet werden. Unser QC-Leitfaden erklärt, was zu prüfen ist und wie Sie Inspektionen anfordern.',
  faq_q8: 'Wie verwende ich ein AllChinaBuy-Spreadsheet?',
  faq_a8: 'Durchsuchen Sie Kategorien, filtern Sie nach Produkttyp, vergleichen Sie Verkäufer und verwenden Sie den Versandrechner, um Kosten vor einer Bestellung zu schätzen.',
  final_cta_title: 'Starten Sie Ihre AllChinaBuy-Recherche',
  final_cta_desc: 'Egal, ob Sie Ihr erstes Produkt recherchieren oder Versand- und Verkäuferoptionen vergleichen, starten Sie mit dem AllChinaBuy Spreadsheet und erkunden Sie die Leitfäden, die Ihren Bedürfnissen entsprechen.',
  footer_disclaimer: 'Dies ist eine unabhängige Informationsressource und nicht die offizielle AllChinaBuy-Website, es sei denn, es wird ausdrücklich angegeben.',
  footer_resources: 'Ressourcen',
  footer_links: 'Links',
  footer_legal: 'Rechtliches',
  breadcrumb_home: 'Startseite',
  article_read_more: 'Vollständigen Guide Lesen',
  article_published: 'Veröffentlicht',
  article_updated: 'Zuletzt Aktualisiert',
  article_author: 'Autor',
  article_related: 'Verwandte Artikel',
  article_sources: 'Quellen',
  article_toc: 'Inhaltsverzeichnis',
  dropdown_label: 'Kategorien Durchsuchen',
  category_button_label: 'Shoppen',
};

export default home;